import { withInstall } from '@zoryn/utils'
import Pagination from './src/pagination'

import type { SFCWithInstall } from '@zoryn/utils'

export const ZPagination: SFCWithInstall<typeof Pagination> =
  withInstall(Pagination)
export default ZPagination

export * from './src/pagination'
export * from './src/constants'
